import { DriveDocument } from '@/api/types/drive'
import { UserProxy } from '@/api/types/user'
import { WorkstationDocument } from '@/api/types/workstation'
import { adminGetAllUsers } from '../api/cloudFunctionWrappers'
import { getActiveResources } from './selectors'

import { groupPerPropertyValue } from './objects'
import { getAllCollectionDocuments } from '@/api/firebase'
import firebase from 'firebase' // for typing

const hasAnyResources = (user: UserProxy) => {
  return user.workstations.length > 0 || user.drives.length > 0
}

export async function getAllUsersInformation(
  db: firebase.firestore.Firestore,
): Promise<UserProxy[]> {
  const usersResult = await adminGetAllUsers()

  const allWorkstations = await getAllCollectionDocuments<WorkstationDocument>(db, 'workstations')
  const workstationsMap = groupPerPropertyValue(allWorkstations, 'owner_id')

  const allDrives = await getAllCollectionDocuments<DriveDocument>(db, 'drives')
  const drivesMap = groupPerPropertyValue(allDrives, 'owner_id')
  return usersResult.data
    .map((user: UserProxy) => {
      const workstations = workstationsMap[user.uid] || []
      const drives = drivesMap[user.uid] || []
      return new UserProxy(
        user.uid,
        user.profile || {},
        user.email,
        user.displayName,
        user.photoURL,
        user.provider,
        getActiveResources(workstations) as WorkstationDocument[],
        getActiveResources(drives) as DriveDocument[],
      )
    })
    .filter(hasAnyResources)
}
